module.exports = __webpack_public_path__ + "static/scale-model-of-aventura-slide-tower-in-hollywood-florida-3ecbe37ee06a556eef03e90f7e039593.png";